import { useCallback, useEffect, useRef, useState } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import PrimaryButton from "../../components/ui/PrimaryButton";
import { v4 as uuid } from "uuid";

export default function BotMsgNode({ data, id }) {
  const reactFlowInstance = useReactFlow();
  const currentNode = reactFlowInstance.getNode(id);

  const textAreaRef = useRef(null);

  const [inputValue, setInputValue] = useState(currentNode.message.en);

  useEffect(() => {
    if (!textAreaRef.current) return;
    textAreaRef.current.style.height = "auto";
    textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;

    data.setNodes((nds) => {
      let count = 0;
      return [
        ...nds.map((nd) => {
          if (nd.parentNode === id) {
            count++;
            return {
              ...nd,
              position: {
                x: 0,
                y: textAreaRef.current.scrollHeight + 5 + 50 * count,
              },
            };
          } else {
            return nd;
          }
        }),
      ];
    });
  }, [textAreaRef.current?.scrollHeight, data, id]);

  const onChange = useCallback(
    (evt) => {
      setInputValue(evt.target.value);
      data.setNodes((nds) =>
        nds.map((nd) =>
          nd.id === id
            ? { ...nd, message: { ...nd.message, en: evt.target.value } }
            : nd
        )
      );
    },
    [data, id]
  );

  const onCheckboxChange = (e) => {
    data.setNodes((nds) =>
      nds.map((nd) =>
        nd.id === id ? { ...nd, imp_msg: e.target.checked } : nd
      )
    );
  };

  const addUserReply = () => {
    const user_reply_id = uuid();
    data.setNodes((nds) => {
      let count = nds.filter((obj) => obj.parentNode === id).length;
      return [
        ...nds.map((nd) =>
          nd.id === id
            ? {
                ...nd,
                user_inputs: [
                  ...nd.user_inputs,
                  {
                    id: user_reply_id,
                    next: "",
                    input: "",
                    message: { en: [], hi: [] },
                    action: "",
                  },
                ],
                default_user_input:
                  count === 0 ? user_reply_id : nd.default_user_input,
              }
            : nd
        ),
        {
          id: user_reply_id,
          type: "userMsgNode",
          position: {
            x: 0,
            y: textAreaRef.current.scrollHeight + 58 + 50 * count,
          },
          data: { parentNodeId: id, setNodes: data.setNodes },
          parentNode: id,
          draggable: false,
        },
      ];
    });
  };
  return (
    <div>
      <Handle type="target" position={Position.Left} />
      <div className={`${currentNode.selected && "border-0 border-black"}`}>
        <div
          className={`rounded ${
            data.isEnd ? "bg-[#ebad25]" : "bg-slate-300"
          } p-2 flex flex-col gap-2 w-[17rem]`}>
          <div className={`flex items-center gap-2`}>
            {/*<label htmlFor="text">Text:</label>*/}
            <textarea
              ref={textAreaRef}
              className={`border border-slate-300 rounded nodrag w-full ${
                data.isEnd && "focus:border focus:border-red-400"
              }`}
              value={inputValue}
              rows={data.isEnd ? 2 : 3}
              id="text"
              name="text"
              onChange={onChange}
            />
            {/*<textarea className="border-2 border-black rounded nodrag"
                    value={inputValue}
                    id="text" name="text" onChange={onHindiChange} />*/}
            {/*{!data.isEnd && <PrimaryButton className="ml-2" text="+" onClick={addUserReply} />}*/}
          </div>
          {!data.isEnd && (
            <div className="flex items-center">
              <div>
                <input
                  onChange={(e) => {
                    onCheckboxChange(e);
                  }}
                  className=""
                  type="checkbox"
                  id="imp_msg"
                  name="imp_msg"
                  value="imp_msg"
                  checked={currentNode.imp_msg}
                />
                <label className="ml-2" htmlFor="imp_msg">
                  Is important
                </label>
              </div>
              <div className="ml-auto">
                <PrimaryButton
                  className="ml-2"
                  text="+"
                  onClick={addUserReply}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
